import React, { useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import '../../static/css/main.css'
import '../../static/fonts/stylesheet.css'
import { selectStepCalc } from './calcSlice';
import { DataPerson } from './dataPerson';
import { DataContract } from './dataContract';
import { DataObject } from './dataObject';
import { StepBuy } from './stepBuy';
import { Contacts } from './contacts';
import { CalculateInsurance } from '../precalc/calcInsurance';

export function CalcBody() {

    const stepCalc = useSelector(selectStepCalc)



    return (
        <>
            <div class="section-calculator-tab-body">
                <div class="section-calculator-tab-body calculator-tab-body-1">

                    {stepCalc === 'contacts' && <Contacts />}

                    {stepCalc === 'data_person' && <DataPerson />}

                    {stepCalc === 'contract' && <DataContract />}

                    {stepCalc === 'object' && <DataObject />}

                    {stepCalc === 'buy' && <StepBuy />}
                </div>
            </div>
        </>
    );
}



